// removed by extract-text-webpack-plugin
module.exports = {"inputs":"user-SignUpFormV2-inputs","buttonWrap":"user-SignUpFormV2-buttonWrap","footLinks":"user-SignUpFormV2-footLinks","title":"user-SignUpFormV2-title","typeSelectLabel":"user-SignUpFormV2-typeSelectLabel","typeSelectContent":"user-SignUpFormV2-typeSelectContent","button":"user-SignUpFormV2-button","email":"user-SignUpFormV2-email","pswd":"user-SignUpFormV2-pswd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/user/SignUpFormV2/index.css
// module id = 1852
// module chunks = 0